import _ from "lodash";
import React, { useEffect } from "react";
import UIButton from "UIComponents/UIButton";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";
import classes from "./Bifurcation.scss";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { recordEvent } from "lib/eventTracker";
import { getCloudUrl } from "Constants";
import { updateBasicUserDetails } from "modules/Services";
import {
  goToToddlePlateform,
  setBifurcationModalStatus,
} from "Login/modules/LoginModule";
import { setDashboardCoachmarkVisibility } from "Teacher/modules/TeacherModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

const toddleUrl = `${getCloudUrl()}/assets/webapp/Bifurcation_platform.png`;

const Bifurcation = ({
  t,
  firstName,
  goToToddlePlateform,
  updateBasicUserDetails,
  bifurcationAction,
  setDashboardCoachmarkVisibility,
  setBifurcationModalStatus,
  name,
  userId,
}) => {
  useEffect(() => {
    if (bifurcationAction) handleClick(bifurcationAction);
    else {
      recordEvent({
        eventName: "Viewed Page",
        eventData: {
          page: "Bifurcation",
          entity_id: userId,
          entity_name: name,
          entity_type: "STAFF",
        },
      });
    }
  }, []);

  const handleClick = async path => {
    switch (path) {
      case "platform":
        await goToToddlePlateform();
        setDashboardCoachmarkVisibility(true);
        break;
    }

    if (!bifurcationAction) {
      recordEvent({
        eventName: "Clicked Bifurcation",
        eventData: {
          target: path,
          entity_id: userId,
          entity_name: name,
          entity_type: "STAFF",
        },
      });
    }

    await updateBasicUserDetails({
      showBifurcationScreen: false,
      portalType: "PLANNER",
    });

    setBifurcationModalStatus(false);
  };

  if (bifurcationAction) return null;

  return (
    <UIModal
      overlayContainer={classes.overlayContainer}
      isOpen={true}
      isFullScreen={true}
    >
      <div className={classes.containerWrapper}>
        <div className={classes.container}>
          <div className={classes.title}>
            {t("community:bifurcation_title", { name: firstName })}
          </div>
          <div className={classes.subTitle}>
            {t("community:bifurcation_subtitle")}
          </div>

          <div className={classes.cardContainer}>
            <div className={classes.card}>
              <div className={classes.imgContainer}>
                <img src={toddleUrl} height={164} alt="" />
              </div>
              <div className={classes.cardTitle}>
                {t("community:explore_platform")}
              </div>
              <div className={classes.cardDescription}>
                {t("community:explore_platform_message")}
              </div>
              <UIButton onClick={() => handleClick("platform")} color="orchid">
                {t("community:explore_toddle")}
              </UIButton>
            </div>
          </div>
        </div>
      </div>
    </UIModal>
  );
};

const mapStateToProps = state => {
  const userInfo = getUserInfo({ portalType: "PLANNER" });
  const name = `${_.get(userInfo, "first_name", "")} ${_.get(
    userInfo,
    "last_name",
    ""
  )}`;
  return {
    name,
    userId: _.get(userInfo, "id"),
    bifurcationAction: _.get(state, "login.bifurcationAction"),
  };
};

const mapActionCreators = {
  goToToddlePlateform,
  updateBasicUserDetails,
  setDashboardCoachmarkVisibility,
  setBifurcationModalStatus,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["community", "common"] })
)(Bifurcation);
